<template>
  <header>
    <div class="content">
      <div class="logo" @click="goToHome">
        <img src="../assets/logo.png" alt="" />
      </div>
      <div class="nav">
        <ul>
          <li v-for="(item, index) in navItems" :key="index">
            <template v-if="item.subItems">
              <!-- 下拉菜单项 -->
              <div
                class="dropdown"
                @mouseenter="showDropdown = true"
                @mouseleave="showDropdown = false"
              >
                <router-link
                  :to="item.path"
                  exact
                  active-class="active"
                  :class="{ active: item.name === '热门项目' && isActiveNews }"
                >
                  {{ item.name }}
                  <img src="../assets/arrowBottom.png" alt="" />
                </router-link>
                <transition name="fade">
                  <ul class="dropdown-menu" v-show="showDropdown">
                    <li
                      v-for="(subItem, subIndex) in item.subItems"
                      :key="subIndex"
                    >
                      <router-link :to="subItem.path">{{
                        subItem.name
                      }}</router-link>
                    </li>
                  </ul>
                </transition>
              </div>
            </template>
            <template v-else>
              <!-- 普通菜单项 -->
              <router-link :to="item.path" exact active-class="active">
                {{ item.name }}
              </router-link>
            </template>
          </li>
        </ul>
      </div>
      <div class="navIcon" @click="goToMenu">
        <img src="@/assets/menu.png" alt="" />
      </div>
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return {
      showDropdown: false,
      navItems: [
        { name: "首页", path: "/" },
        { name: "房源列表", path: "/properties" },
        {
          name: "热门项目",
          path: "#",
          subItems: [
            { name: "移民项目", path: "/news/immigration" },
            { name: "留学教育", path: "/news/education" },
            { name: "境外生活", path: "/news/living" },
            { name: "资讯百科", path: "/news/knowledge" },
          ],
        },
      ],
    };
  },
  computed: {
    isActiveNews() {
      return this.$route.path.startsWith("/news/");
    },
  },
  methods: {
    goToHome() {
      this.$router.push("/");
    },
    goToMenu() {
      this.$router.push("/Menu");
    },
    handleNewsClick(e) {
      // 如果设为 "#"，需要阻止默认行为
      e.preventDefault();
    },
  },
};
</script>

<style scoped lang="less">
li {
  list-style: none;
}
a {
  text-decoration: none;
}
@media (max-width: 576px) {
  header {
    .content {
      align-items: center;
      padding: 18px 30px;
      padding-right: 35px;
      box-sizing: border-box;
      height: 64px;
      .logo {
        width: 163px;
        height: 28px;
        margin-bottom: 0;
        img {
        }
      }
    }
    .navIcon {
      padding: 25px 0;
      box-sizing: border-box;
      img {
        width: 14px;
        height: 14px;
      }
    }
  }

  .nav {
    display: none !important;
  }
}
@media (min-width: 577px) {
  .navIcon {
    display: none;
  }
}
header {
  position: relative;
  z-index: 1;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(51px);
  border-bottom: 1px solid #cdcdd2;
}
.content {
  width: 100%;
  max-width: 75rem;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 21px 0 0px;
  .logo {
    cursor: pointer;
    margin-bottom: 20px;
    width: 233px;
    height: 40px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .nav {
    display: flex;
    align-items: center;
    position: relative;

    ul {
      display: flex;

      li {
        position: relative;
        margin-left: 60px;
        cursor: pointer;
        a {
          font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
          font-weight: 400;
          font-size: 18px;
          color: #1c1d25;
          // padding: 0px 15px;
          padding-bottom: 29px;
          box-sizing: border-box;
          display: block;
          &.active {
            border-bottom: 3px solid #026af9;
          }
        }

        &:first-child {
          margin-left: 0;
        }
      }
    }
  }
}
/* 下拉菜单样式 */
.dropdown {
  position: relative;

  img {
    width: 9px;
    height: 5px;
    margin-left: 5px;
    vertical-align: middle;
  }

  .dropdown-menu {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: -20%;
    z-index: 100;
    width: 117px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(21, 21, 21, 0.13);
    border-radius: 5px 5px 5px 5px;
    padding: 7px 0;
    li {
      margin: 0 !important;
      // border-bottom: 1px solid #eee;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px 0;
      &:hover {
        background: rgba(51, 113, 252, 0.1);
        border-left: 1px solid #3371fc;
      }
      a {
        // padding: 8px 20px;
        padding-bottom: 0 !important;
        display: block;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #121212;
        text-align: center;
        &.active {
          border-bottom: none;
          color: #026af9;
          background: #f5f5f5;
        }
      }
    }
    li:last-child {
      border-bottom: 0;
    }
  }
}
</style>
